module.exports = __webpack_public_path__ + "static/media/Amit ji 1.7c62ba29.png";